export const companyAllowedRoutes = [
  '/dashboard',
  '/account',
  '/board-meetings',
  '/post/:postId?',
  '/:companySlug/posts',
  '/advisors',
  '/advisors/search',
  '/advisors/saved',
  '/advisors/top_matches',
  '/advisors/:publicProfileUrl',
  '/advisor_ideas',
  '/company/onboarding/terms-of-service',
  '/company/onboarding/step1',
  '/company/onboarding/step2',
  '/company/onboarding/step3',
  '/company/onboarding/step4',
  '/company/onboarding/step5',
  '/company/onboarding/call',
  '/company/onboarding',
  '/company-member/onboarding/profile',
  '/onboarding/call/upgrade',
  '/company-member/welcome',
  '/ub',
  '/wf',
  '/messages',
];
